<template>
  <sui-page>
    <!-- Page Header -->
    <sui-page-header title="[Samples] Range Date Picker" />

    <!-- Page Contents -->
    <sui-page-contents>
      <div class="row">
        <button
          style="width:100px; border:1px solid red;"
          @click="onClickToSetDate"
        >
          set date
        </button>
        <button
          style="width:100px; border:1px solid red;"
          @click="onClickToClear"
        >
          clear date
        </button>
        <button
          style="width:100px; border:1px solid red;"
          @click="onClickActivate"
        >
          activate
        </button>
        <button
          style="width:100px; border:1px solid red;"
          @click="onClickValidate"
        >
          validate
        </button>
      </div>

      <div class="comm_title_wrap">
        <h5>Date Picker</h5>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label label="date picker" />
        </div>
        <div class="col-xs-3">
          <sui-date-picker ref='dp' v-model="selectedRangeDate.datePicker" />
        </div>
        <div class="col-xs-8">
          <span class="info caution">{{ selectedRangeDate.datePicker }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label label="date picker" />
        </div>
        <div class="col-xs-3">
          <sui-date-picker ref='dp2' v-model="selectedRangeDate.datePicker1" />
        </div>
        <div class="col-xs-8">
          <span class="info caution">{{ selectedRangeDate.datePicker1 }}</span>
        </div>
      </div>

      <div class="comm_title_wrap">
        <h5>Range Date Picker</h5>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label label="null type" />
        </div>
        <div class="col-xs-3">
          <sui-range-date-picker
            ref='rp'
            v-model="selectedRangeDate.nullType"
            @confirm="onConfirm"
          />
        </div>
        <div class="col-xs-8">
          <span class="info caution">{{ selectedRangeDate.nullType }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label label="string type" />
        </div>
        <div class="col-xs-3">
          <sui-range-date-picker
            ref='rp2'
            v-model="selectedRangeDate.stringType"
            @confirm="onConfirm"
          />
        </div>
        <div class="col-xs-8">
          <span class="info caution">{{ selectedRangeDate.stringType }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label label="object null type" />
        </div>
        <div class="col-xs-3">
          <sui-range-date-picker
            v-model="selectedRangeDate.objectNullType"
            @confirm="onConfirm"
          />
        </div>
        <div class="col-xs-8">
          <span class="info caution">{{ selectedRangeDate.objectNullType }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label label="object type" />
        </div>
        <div class="col-xs-3">
          <sui-range-date-picker
            v-model="selectedRangeDate.objectType"
            @confirm="onConfirm"
          />
        </div>
        <div class="col-xs-8">
          <span class="info caution">{{ selectedRangeDate.objectType }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label label="string type" />
        </div>
        <div class="col-xs-3">
          <sui-range-date-picker
            v-model="selectedRangeDate.stringType"
            readonly
          />
        </div>
        <div class="col-xs-8">
          <span class="info">// readonly &nbsp;&nbsp;</span>
          <span class="info caution">{{ selectedRangeDate.stringType }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label label="string type" />
        </div>
        <div class="col-xs-3">
          <sui-range-date-picker
            v-model="selectedRangeDate.stringType"
            disabled
          />
        </div>
        <div class="col-xs-8">
          <span class="info">// disabled &nbsp;&nbsp;</span>
          <span class="info caution">{{ selectedRangeDate.stringType }}</span>
        </div>
      </div>

      <div class="comm_title_wrap">
        <h5>with Dataset</h5>
      </div>

      <div class="row">
        <div class="col-xs-1">
          <sui-input-label label="dataset object type" />
        </div>
        <div class="col-xs-3">
          <sui-range-date-picker
            v-model="selectedRangeDate.dataset"
            dataset="dataset0.rangeDate"
            @confirm="onConfirm"
          />
        </div>
        <div class="col-xs-8">
          <span class="info caution">{{ selectedRangeDate.dataset }}</span>
          <span class="info">{{ dataset0.rangeDate }}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-1">
          <sui-input-label label="dataset string type" />
        </div>
        <div class="col-xs-3">
          <sui-range-date-picker
            v-model="selectedRangeDate.datasetString"
            dataset="dataset0.rangeDateString"
            @confirm="onConfirm"
          />
        </div>
        <div class="col-xs-8">
          <span class="info caution">{{ selectedRangeDate.datasetString }}</span>
          <span class="info">{{ dataset0.rangeDateString }}</span>
        </div>
      </div>

      <div class="comm_title_wrap">
        <h5>with Dataset Grid</h5>
      </div>
      <div class="row">
        <sui-jqx-grid
          ref="grid"
          :columns="gridColumns0"
          width="100%"
          :dataset="'dataset0'"
          :sortable="true"
        />
      </div>
    </sui-page-contents>
  </sui-page>
</template>

<script>
export default {
  name: 'DatasetWithComponent',
  data() {
    return {
      selectedRangeDate: {
        datePicker: null,
        datePicker1: '2019-08-20',
        nullType: null,
        stringType: '2019-01-01~2019-01-03',
        objectNullType: {
          from: '',
          to: '',
        },
        objectType: {
          from: '2019-05-01',
          to: '',
        },
        // dataset: { from: '2019-11-10', to: '2019-11-15' },
        dataset: { from: '', to: '' },
        datasetString: '',
      },
      gridColumns0: [{
        text: '모듈',
        datafield: 'moduleCode',
        width: 90,
      }, {
        text: '서브모듈',
        datafield: 'subModuleCode',
      }, {
        text: '페이지유형',
        datafield: 'pageTypeCode',
        cellsalign: 'center',
      }, {
        text: '페이지 ID',
        datafield: 'pageId',
      }, {
        text: '페이지 명',
        datafield: 'pageName',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellTextField(row, column, value, htmlElement, {
            trim: true,
          }, this.dataset0);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: '페이지 상태',
        datafield: 'pageStatusCode',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellSelect(row, column, value, htmlElement, {
            optionList: this.customOptions,
          }, this.dataset0);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: '사용여부',
        datafield: 'pageUseYn',
        $component: this,
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellRadioGroup(row, column, value, htmlElement, {
            items: [{ key: 'Y', label: 'Yes' }, { key: 'N', label: 'No' }],
          }, this.dataset0, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: '수정자',
        datafield: 'finalModificationUserId',
      }, {
        text: '수정일시',
        datafield: 'finalModificationDTM',
        $component: this,
        createwidget(row, column, value, htmlElement) {
          console.log(row, column, value, htmlElement);
          // console.log(this.$component);
          // const targetData = this.dataset0.data;
          // utils.getGridCellFactory().createCellDatePicker(row, column, value, htmlElement, this.dataset0);
        },
        initwidget(row, column, value, htmlElement) {
          console.log(row, column, value, htmlElement);
          // console.log(this.$component);
        },
      }],
      localdata0: [
        {
          deleteYn: 'N',
          firstRegistrationDTM: '20190510125920',
          firstRegistrationUserId: 'chiwoo.seo',
          firstRegistrationProgramId: 'PGE_CMU_00001',
          finalModificationDTM: '2019-05-10 12:59:20',
          finalModificationUserId: 'chiwoo.seo',
          finalModificationProgramId: 'PGE_CMU_00001',
          pageId: 'PGE_CMS_00000',
          moduleCode: 'CM',
          subModuleCode: 'S',
          pageName: '배치작업이력',
          pageTitleMessageResourceId: 'MSG_CM_TIT_BCJB_HIS',
          pageTypeCode: 'N',
          pageDestinationValue: '/CM/pages/S/PGE_CMS_00005.vue',
          pageStatusCode: 'D',
          pageBlockContent: '차단된 페이지입니다.',
          pageUseYn: 'Y',
          pageUsePriodYn: 'N',
          pageUsePriodStartDatetime: moment('2019-05-10'),
          pageUsePriodFinishDatetime: '9999-12-31',
          pagePopupYn: 'N',
          pagePopupOptionValue: null,
          searchPageCond: null,
          searchPageText: null,
          lang: 'en',
          rangeDate: {
            from: '2019-01-10',
            to: '2019-02-15',
          },
          rangeDateString: '2019-01-10~2019-02-15',
        }, {
          deleteYn: 'N',
          firstRegistrationDTM: '20190510125920',
          firstRegistrationUserId: 'chiwoo.seo',
          firstRegistrationProgramId: 'PGE_CMU_00003',
          finalModificationDTM: '2019-05-10 12:59:20',
          finalModificationUserId: 'chiwoo.seo',
          finalModificationProgramId: 'PGE_CMU_00003',
          pageId: 'PGE_CMS_00001',
          moduleCode: 'CM',
          subModuleCode: 'S',
          pageName: '배치작업이력',
          pageTitleMessageResourceId: 'MSG_CM_TIT_BCJB_HIS',
          pageTypeCode: 'N',
          pageDestinationValue: '/CM/pages/S/PGE_CMS_00005.vue',
          pageStatusCode: 'D',
          pageBlockContent: '차단된 페이지입니다.',
          pageUseYn: 'N',
          pageUsePriodYn: 'N',
          pageUsePriodStartDatetime: '20190510125916',
          pageUsePriodFinishDatetime: '99991231235959',
          pagePopupYn: 'N',
          pagePopupOptionValue: null,
          searchPageCond: null,
          searchPageText: null,
          lang: 'en',
          rangeDate: {
            from: null,
            to: '2019-03-15',
          },
          rangeDateString: '~2019-03-15',
        }, {
          deleteYn: 'N',
          firstRegistrationDTM: '20190510125920',
          firstRegistrationUserId: 'chiwoo.seo',
          firstRegistrationProgramId: 'PGE_CMU_00005',
          finalModificationDTM: '2019-05-10 12:59:20',
          finalModificationUserId: 'chiwoo.seo',
          finalModificationProgramId: 'PGE_CMU_00005',
          pageId: 'PGE_CMS_00002',
          moduleCode: 'CM',
          subModuleCode: 'S',
          pageName: '배치작업이력',
          pageTitleMessageResourceId: 'MSG_CM_TIT_BCJB_HIS',
          pageTypeCode: 'N',
          pageDestinationValue: '/CM/pages/S/PGE_CMS_00005.vue',
          pageStatusCode: 'D',
          pageBlockContent: '차단된 페이지입니다.',
          pageUseYn: 'Y',
          pageUsePriodYn: 'N',
          pageUsePriodStartDatetime: '20190510125916',
          pageUsePriodFinishDatetime: '99991231235959',
          pagePopupYn: 'N',
          pagePopupOptionValue: null,
          searchPageCond: null,
          searchPageText: null,
          lang: 'en',
          rangeDate: {
            from: '2019-03-10',
            to: null,
          },
          rangeDateString: '2019-03-10~',
        }, {
          deleteYn: 'N',
          firstRegistrationDTM: '20190510125920',
          firstRegistrationUserId: 'chiwoo.seo',
          firstRegistrationProgramId: 'PGE_CMU_00002',
          finalModificationDTM: '2019-05-10 12:59:20',
          finalModificationUserId: 'chiwoo.seo',
          finalModificationProgramId: 'PGE_CMU_00002',
          pageId: 'PGE_CMS_00003',
          moduleCode: 'CM',
          subModuleCode: 'S',
          pageName: '배치작업이력',
          pageTitleMessageResourceId: 'MSG_CM_TIT_BCJB_HIS',
          pageTypeCode: 'N',
          pageDestinationValue: '/CM/pages/S/PGE_CMS_00005.vue',
          pageStatusCode: 'D',
          pageBlockContent: '차단된 페이지입니다.',
          pageUseYn: 'N',
          pageUsePriodYn: 'N',
          pageUsePriodStartDatetime: '20190510125916',
          pageUsePriodFinishDatetime: '99991231235959',
          pagePopupYn: 'N',
          pagePopupOptionValue: null,
          searchPageCond: null,
          searchPageText: null,
          lang: 'en',
          rangeDate: {
            from: '2019-07-10',
            to: '2019-07-15',
          },
          rangeDateString: '2019-07-10~2019-07-15',
        },
      ],
    };
  },
  mounted() {
  },
  datasets: [{
    id: 'dataset0',
    type: 'local',
    data: 'localdata0',
    datafields: [{
      name: 'deleteYn',
      type: 'string',
      map: 'deleteYn',
    },
    {
      name: 'firstRegistrationDTM',
      type: 'string',
      map: 'firstRegistrationDTM',
    },
    {
      name: 'firstRegistrationUserId',
      type: 'string',
      map: 'firstRegistrationUserId',
    },
    {
      name: 'firstRegistrationProgramId',
      type: 'string',
      map: 'firstRegistrationProgramId',
    },
    {
      name: 'finalModificationDTM',
      type: 'string',
      map: 'finalModificationDTM',
    },
    {
      name: 'finalModificationUserId',
      type: 'string',
      map: 'finalModificationUserId',
    },
    {
      name: 'finalModificationProgramId',
      type: 'string',
      map: 'finalModificationProgramId',
    },
    {
      name: 'pageId',
      type: 'string',
      map: 'pageId',
    },
    {
      name: 'moduleCode',
      type: 'string',
      map: 'moduleCode',
    },
    {
      name: 'subModuleCode',
      type: 'string',
      map: 'subModuleCode',
    },
    {
      name: 'pageName',
      type: 'string',
      map: 'pageName',
    },
    {
      name: 'pageTitleMessageResourceId',
      type: 'string',
      map: 'pageTitleMessageResourceId',
    },
    {
      name: 'pageTypeCode',
      type: 'string',
      map: 'pageTypeCode',
    },
    {
      name: 'pageDestinationValue',
      type: 'string',
      map: 'pageDestinationValue',
    },
    {
      name: 'pageStatusCode',
      type: 'string',
      map: 'pageStatusCode',
    },
    {
      name: 'pageBlockContent',
      type: 'string',
      map: 'pageBlockContent',
    },
    {
      name: 'pageUseYn',
      type: 'string',
      map: 'pageUseYn',
    },
    {
      name: 'pageUsePriodYn',
      type: 'string',
      map: 'pageUsePriodYn',
    },
    {
      name: 'pageUsePriodStartDatetime',
      type: 'string',
      map: 'pageUsePriodStartDatetime',
    },
    {
      name: 'pageUsePriodFinishDatetime',
      type: 'string',
      map: 'pageUsePriodFinishDatetime',
    },
    {
      name: 'pagePopupYn',
      type: 'string',
      map: 'pagePopupYn',
    },
    {
      name: 'pagePopupOptionValue',
      type: 'string',
      map: 'pagePopupOptionValue',
    },
    {
      name: 'searchPageCond',
      type: 'string',
      map: 'searchPageCond',
    },
    {
      name: 'searchPageText',
      type: 'string',
      map: 'searchPageText',
    },
    {
      name: 'lang',
      type: 'string',
      map: 'lang',
    },
    {
      name: 'rangeDate',
      type: 'string',
      map: 'rangeDate',
    },
    {
      name: 'rangeDateString',
      type: 'string',
      map: 'rangeDateString',
    },
    ],
  }],
  methods: {
    onConfirm(value) {
      console.log(`[Sample]RangeDatePicker.onClickToSetDate(): ${JSON.stringify(value)}`);
    },
    onClickToSetDate() {
      console.log('[Sample]RangeDatePicker.onClickToSetDate() was called.');
      this.selectedRangeDate.datePicker = '2019-01-01';
      this.selectedRangeDate.datePicker1 = '2019-01-01';
      this.selectedRangeDate.nullType = '2019-01-01~2019-03-15';
      // this.selectedRangeDate.stringType = '2019-01-01~2019-03-15';
      this.$refs.rp2.setDateStr('2019-01-01~2019-03-15');
      this.selectedRangeDate.objectNullType = { from: '2019-01-01', to: new Date() };
      this.selectedRangeDate.objectType = { from: '2019-01-01', to: '2019-03-15' };
    },
    onClickToClear() {
      console.log('[Sample]RangeDatePicker.onClickToClear() was called.');
      this.selectedRangeDate.datePicker = null;
      this.selectedRangeDate.datePicker1 = null;
      this.selectedRangeDate.nullType = null;
      this.selectedRangeDate.stringType = null;
      this.selectedRangeDate.objectNullType = { from: null, to: null };
      this.selectedRangeDate.objectType = { from: null, to: null };
    },
    onClickActivate() {
      this.$refs.rp.activate();
    },
    onClickValidate() {
      if (this.$refs.dp.isValid() && this.$refs.dp2.isValid() && this.$refs.rp.isValid() && this.$refs.rp2.isValid()) {
        utils.messageBox('success', '입력값이 정상입니다', null, null);
      } else {
        utils.messageBox('warning', '입력값이 비정상 입니다', null, null);
      }
    },
    positiveHandler() {

    },
  },
};
</script>
